import { ReactElement } from 'react';
import { TransitionCard } from '../Transition/TransitionCard';
import { TransitionScreenWrapper } from '../Transition/TransitionScreenWrapper';
import { AnimatedProgressBar } from './AnimatedProgressBar';

interface Props {
  errorButton: (handleRestart: () => void) => ReactElement | null;
  isError: boolean;
  isPaused?: boolean;
  children: ({ progress }: { progress: number }) => ReactElement;
}

export const BookingBuilderContainer = ({ errorButton, isError, isPaused, children }: Props) => {
  return (
    <TransitionScreenWrapper>
      <TransitionCard>
        <AnimatedProgressBar
          actionButton={({ handleRestart }) => (isError ? errorButton(handleRestart) : null)}
          finishedNumber={99}
          intervalDelayInSeconds={6}
          isPaused={isPaused ?? isError}
        >
          {children}
        </AnimatedProgressBar>
      </TransitionCard>
    </TransitionScreenWrapper>
  );
};
